import Cookies from 'js-cookie'
import type {CurrentUser} from 'types/store/session'

const defaultLimit = '10'

const limitKey = (pathname: string, user: CurrentUser) => `${pathname.replace(/\//g, '')}#${user.id}__disp_emp_limit`

export const getSavedDisplayTypeLimit = (pathname: string, user: CurrentUser) => {
  return window.localStorage?.getItem(limitKey(pathname, user)) || Cookies.get(limitKey(pathname, user)) || defaultLimit
}

export const saveDisplayTypeLimit = (pathname: string, user: CurrentUser, limit: number) => {
  const limitStr = limit.toString()
  if (window.localStorage) {
    window.localStorage.setItem(limitKey(pathname, user), limitStr)
  } else {
    Cookies.set(limitKey(pathname, user), limitStr)
  }
}
